module.exports = __webpack_public_path__ + "img/s_stoichev.71d13377.jpg";